import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import auth from "../../../services/security/auth.service";
import constants from "../../../utils/constants";
import CircularProgress from '@mui/material/CircularProgress';
import TokenService from "../../../services/security/token.service";
import AuthService from "../../../services/security/auth.service";

const defaultTheme = createTheme();

const Reset = () => {
    let navigate = useNavigate();
    const [dni, setDni] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [errors, setErrors] = useState({ dni: '', email: '', password: '', password1: '', api: '' });
    const [load, setLoad] = useState(false);

    useEffect(() => {
        document.title = `wBroker`;

    })
    const onChangeDNI = (event) => {

        if (event.target.value !== '') {
            if (isValidDni(event.target.value)) {
                setDni(event.target.value);
            }
        } else {
            setDni(event.target.value);
        }
        setErrors({ ...errors, dni: event.target.value.trim() ? '' : 'DNI es obligatorio' });
    }

    const onChangeEmail = (event) => {
        setEmail(event.target.value);
        setErrors({ ...errors, email: event.target.value.trim() ? '' : 'Email es obligatorio' });
    }

    const onChangePassword = (event) => {
        setPassword(event.target.value);
        setErrors({ ...errors, password: event.target.value.trim() ? '' : 'Contraseña es obligatoria' });
    }

    const onChangePassword1 = (event) => {
        if (event.target.value !== password) {
            setErrors({ ...errors, password1: 'La contraseña debe coincidir' });
        }
        setPassword1(event.target.value);
        setErrors({ ...errors, password1: event.target.value.trim() ? '' : 'Contraseña es obligatoria' });
    }

    const isValidDni = (dni) => {
        return /^[0-9]+$/.test(dni);
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onValidateEmail = (e) => {
        if (e.target.value) {
            if (!isValidEmail(e.target.value)) {
                setErrors({ ...errors, email: 'El email es inválido' });
            }
        }
    };

    const onValidatePassword = (e) => {

        const value = e.target.value;

        if (!value.trim()) {
            setErrors({
                ...errors,
                password: 'Contraseña es obligatoria'
            });

            return;
        }

        if (value.length < 8) {
            setErrors({
                ...errors,
                password: 'La contraseña debe tener al menos 8 caracteres'
            });

            return;
        }

        if (!/[A-Z]/.test(value)) {
            setErrors({
                ...errors,
                password: 'La contraseña debe contener al menos una mayúscula'
            });

            return;
        }

        if (!/[a-z]/.test(value)) {
            setErrors({
                ...errors,
                password: 'La contraseña debe contener al menos una minúscula'
            });

            return;
        }

        if (!/[0-9]/.test(value)) {
            setErrors({
                ...errors,
                password: 'La contraseña debe contener al menos un número'
            });

            return;
        }

        if (!/[!@#$%^&*(),.?":{}|<>_\-]/.test(value)) {
            setErrors({
                ...errors,
                password: 'La contraseña debe contener al menos un carácter especial (!, #, $, etc.)'
            });

            return;
        }

        setErrors({
            ...errors,
            password: ''
        });
    };

    const isValidPassword = (password) => {
        return (
            password.length >= 8 &&
            /[A-Z]/.test(password) &&      // Mayúscula
            /[a-z]/.test(password) &&      // Minúscula
            /[0-9]/.test(password) &&      // Número
            /[!@#$%^&*(),.?":{}|<>_\-]/.test(password) // Especial
        );
    };

    const registerUser = () => {
        setLoad(true);
        let formErrors = {};
        if (!dni.trim()) {
            formErrors.dni = 'DNI es obligatorio';
        }
        if (!email.trim()) {
            formErrors.email = 'Email es obligatorio';
        } else {
            if (!isValidEmail(email)) {
                formErrors.email = 'El email es inválido';
            }
        }
        if (!password.trim()) {

            formErrors.password =
                'Contraseña es obligatoria';

        } else if (!isValidPassword(password)) {

            if (password.length < 8) {

                formErrors.password =
                    'La contraseña debe tener al menos 8 caracteres';

            } else if (!/[A-Z]/.test(password)) {

                formErrors.password =
                    'La contraseña debe contener al menos una mayúscula';

            } else if (!/[a-z]/.test(password)) {

                formErrors.password =
                    'La contraseña debe contener al menos una minúscula';

            } else if (!/[0-9]/.test(password)) {

                formErrors.password =
                    'La contraseña debe contener al menos un número';

            } else {

                formErrors.password =
                    'La contraseña debe contener al menos un carácter especial (!, #, $, etc.)';

            }
        }
        if (!password1.trim()) {
            formErrors.password1 = 'Contraseña es obligatoria';
        } else {
            if (password1 !== password) {
                formErrors.password1 = 'La contraseña debe coincidir';
            }
        }

        setErrors(formErrors);

        if (Object.keys(formErrors).length > 0) {
            setLoad(false);
            return;
        }

        let request = {
            "email": `${email}`,
            "password": `${password}`,
            "dni": `${dni}`,
            "client": constants.CLIENT
        }
        auth.register(request).then((response) => {

            if (response.data.message.includes('Error')) {
                setErrors({ ...errors, api: response.data.message });
                setLoad(false);
            } else {
                setTimeout(() => {
                    auth.login(email, password, dni, constants.CLIENT).then(
                        (response) => {
                            console.log('RESPUESTA LOGIN-> ' + JSON.stringify(response))
                            if (response.instances.length <= 1) {
                                if (response.instances[0].roles.length <= 1) {
                                    let dataUser = TokenService.getUser();
                                    dataUser.data = response.instances[0].roles[0];
                                    dataUser.data.instance = response.instances[0].name;
                                    TokenService.setUser(dataUser);
                                    AuthService.addLogin(email, password, dni, constants.CLIENT, response.instances[0].roles[0].role, response.instances[0].name, response.instances[0].roles[0].entityId);
                                    let landingPage = response.instances[0].roles[0].landingPage;
                                    if (landingPage)
                                        navigate(`/${landingPage}`);
                                    else
                                        navigate(`/home`);
                                    //window.location.reload();
                                    setLoad(false);
                                } else {
                                    const dataJson = JSON.stringify(response);
                                    navigate(`/listlogin?data=${encodeURIComponent(dataJson)}`);
                                    setLoad(false);
                                }
                            } else {
                                const dataJson = JSON.stringify(response);
                                navigate(`/listlogin?data=${encodeURIComponent(dataJson)}`);
                                setLoad(false);
                            }
                            setLoad(false);
                        },
                        (error) => {
                            setLoad(false);
                        }
                    );
                }, 5000);
            }

            //setErrors({ ...errors, api: '' });

            //navigate("/");
            //window.location.reload();
        }).catch((error) => {
            setLoad(false);
            console.log(error);
        });

    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'blue' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Registrar Usuario
                    </Typography>
                    <Box component="form" sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete="dni"
                                    name="dni"
                                    required
                                    fullWidth
                                    id="dni"
                                    label="DNI"
                                    autoFocus
                                    value={dni}
                                    onChange={onChangeDNI}
                                    error={!!errors.dni}
                                    helperText={errors.dni}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    name="email"
                                    autoComplete="email"
                                    value={email}
                                    onChange={onChangeEmail}
                                    onBlur={onValidateEmail}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="password"
                                    label="Contraseña"
                                    type="password"
                                    id="password"
                                    autoComplete="new-password"
                                    value={password}
                                    onChange={onChangePassword}
                                    onBlur={onValidatePassword}
                                    error={!!errors.password}
                                    helperText={errors.password}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="password1"
                                    label="Ingresar Contraseña nuevamente"
                                    type="password"
                                    id="password1"
                                    autoComplete="new-password1"
                                    value={password1}
                                    onChange={onChangePassword1}
                                    error={!!errors.password1}
                                    helperText={errors.password1}
                                />
                            </Grid>
                        </Grid>
                        {!load && (
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={registerUser}
                            >
                                Registrar
                            </Button>
                        )}
                        {load && (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <CircularProgress size={50} />
                            </div>
                        )}
                        {errors.api && (
                            <Typography variant="body2" color="error">
                                {errors.api}
                            </Typography>
                        )}
                    </Box>
                    <Box
                        sx={{
                            border: '2px solid #bbbbbb',
                            padding: '12px 14px',
                            marginTop: 2,
                            color: 'rgba(0, 0, 0, 0.5)',
                            fontSize: '0.75rem',
                            lineHeight: 1.4
                        }}
                    >
                        <div>
                            La contraseña debe contener al menos:
                        </div>

                        <ul
                            style={{
                                marginTop: 4,
                                marginBottom: 0,
                                paddingLeft: 18
                            }}
                        >
                            <li>8 caracteres</li>
                            <li>1 mayúsculas</li>
                            <li>1 minúsculas</li>
                            <li>1 número</li>
                            <li>1 caracter especial (!,#,$,...)</li>
                        </ul>
                    </Box>
                </Box>
            </Container>
        </ThemeProvider>
    )
}

export default Reset

